module.exports = __webpack_public_path__ + "img/рз_16.21f57be8.png";